import React from "react";

const SelectItem = ({options = [], onChange, value, text, cssClasses, disabled = false, testid = 'select-item-select' }) => {
    return (
        <div className={`select-item-container`}>
            <div className={`flex`}>
                <label className={`select-item-label`}>
                    {text}
                    <select
                        className={`select-item-select ${cssClasses} ${disabled ? 'disabled' : ''}`}
                        data-testid={testid}
                        value={value}
                        onChange={e => onChange(e.target.value)}
                        disabled={disabled}>
                        {options.map((option, idx) => (
                            <option key={idx}
                                    value={option.value}
                                    data-testid={`option-${idx}`}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </label>
            </div>
        </div>
    );
};

export default SelectItem;
